// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';
var EditExecutionTimeDialogController = function ($rootScope, $scope, $modalInstance, $http, id, title, objectToEdit, successCallback) {    
    $scope.title = title;    
    const convertDurationToDaysHoursMinutes=function(obj){
        if (obj){
            const duration=moment.duration(obj);
            return {
                Days: duration.days(),
                Hours: duration.hours(),
                Minutes: duration.minutes()
            }
        }
        return {};
    };
    
    const convertDaysHoursMinutesToDuration=function(obj){
        if(obj){
            const days = obj.Days? obj.Days: 0;
            const hours = obj.Hours? obj.Hours: 0;
            const minutes =  obj.Minutes? obj.Minutes: 0;
            //default .net json format for TimeSpan: 1.00:00:00
            return days+'.'+hours+':'+minutes+':00';
        }        
        throw new Error("Error converting days, hours, minutes to duration!");
    }
    
    $scope.actionDelta = convertDurationToDaysHoursMinutes(objectToEdit && objectToEdit.ActionDelta);
    $scope.actionDelta.isDefault = objectToEdit && objectToEdit.DefaultActionDelta === objectToEdit.ActionDelta;
    $scope.inactivePeriod={
        From: objectToEdit && objectToEdit.InactivityPeriodFrom,
        To: objectToEdit && objectToEdit.InactivityPeriodTo,
    };
    
    const getDateTimeProperlyFormatted=function(obj){
        if (obj){
            //input type=time returns hours and minutes
            //.net serializer requires whole value with seconds
            const duration=moment.duration(obj);
            return moment.utc(duration.asMilliseconds()).format("HH:mm")+":00";
        }
        return null;
    };

    $scope.setDefaultActionDelta = function(){
        $scope.actionDelta = convertDurationToDaysHoursMinutes(objectToEdit && objectToEdit.DefaultActionDelta);
    };
    
    $scope.update = function () {    
        let actionDelta;
        if($scope.actionDelta.isDefault){
            actionDelta=null;
        }
        else{
            actionDelta = convertDaysHoursMinutesToDuration($scope.actionDelta);
            if (objectToEdit && actionDelta===objectToEdit.DefaultActionDelta)
                actionDelta=null;
        }
        
        const data={
            ActionDelta: $scope.actionDelta.isDefault
                ? null
                : convertDaysHoursMinutesToDuration($scope.actionDelta),
            InactivityPeriodFrom: getDateTimeProperlyFormatted($scope.inactivePeriod.From),
            InactivityPeriodTo: getDateTimeProperlyFormatted($scope.inactivePeriod.To) };        
        
        $http.put('/api/v1/prometheusActions/' + id+'/executionTime', data)
            .then(
                function (response) {
                    $modalInstance.close();
                    if (successCallback)
                        successCallback();
                });        
    };
    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};

EditExecutionTimeDialogController.$inject = ['$rootScope', '$scope', '$modalInstance', '$http', 'id', 'title', 'objectToEdit', 'successCallback'];
